import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { updateCustomerNokInfo } from "../../../../redux/slice/customer/customerSlice";
import Select from "../../../form/select/Select";

const gender = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
];
const NextOfKin = ({ data, data1 }) => {
  const [editing, setEditing] = useState(false);
  const [editCustomer, setEditCustomer] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();

  const handleClose = () => {
    values.nok_first_name = data?.nok_first_name;
    values.nok_last_name = data?.nok_last_name;
    values.nok_phone = data?.nok_phone;
    values.nok_gender = data?.nok_gender;
    values.nok_address = data?.nok_address;
    values.nok_type_of_relationship = data?.nok_type_of_relationship;
    values.nok_middle_name = data?.nok_middle_name;
    values.nok_email = data?.nok_email;
  };

  const onSubmit = (values) => {
    let payload = { ...values, id: data.customer_uuid };
    dispatch(updateCustomerNokInfo(payload));
  };

  const validationScehma = Yup.object().shape({
    nok_first_name: Yup.string("First Name must be a string").required(
      "First Name cannot be blank"
    ),
    nok_last_name: Yup.string("Last Name must be a string").required(
      "Last Name cannot be blank"
    ),
    nok_phone: Yup.string("Phone number must be a string").required(
      "Phone number cannot be blank"
    ),
    nok_gender: Yup.string("Gender must be a string").required(
      "Gender cannot be blank"
    ),
    nok_address: Yup.string("Address must be a string").required(
      "Address cannot be blank"
    ),
    nok_type_of_relationship: Yup.string(
      "Relationship must be a string"
    ).required("Relationship cannot be blank"),
    // nok_middle_name: Yup.string("Middle name must be a string").required(
    //   "Middle name cannot be blank"
    // ),
    nok_email: Yup.string("First Name must be a string").required(
      "Email cannot be blank"
    ),
  });
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      nok_first_name: data?.nok_first_name || "",
      nok_last_name: data?.nok_last_name || "",
      nok_phone: data?.nok_phone || "",
      nok_gender: data?.nok_gender || "",
      nok_address: data?.nok_address || "",
      nok_type_of_relationship: data?.nok_type_of_relationship || "",
      nok_middle_name: data?.nok_middle_name || "",
      nok_email: data?.nok_email || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });
  const genderData = gender?.map((role) => {
    return {
      label: role.name,
      value: role.id,
    };
  });

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - individual"
      )
    );
  }, [user_permissions]);
  return (
    <>
      <form
        className='border p-3 rounded-3 mt-4 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Next of Kin
        </h4>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      FIRST NAME
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{data?.nok_first_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='nok_first_name'
                          value={values.nok_first_name}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.nok_first_name && touched?.nok_first_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.nok_first_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      LAST NAME
                    </label>
                    {!editing ? (
                      <p>{data?.nok_last_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='nok_last_name'
                          value={values.nok_last_name}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.nok_last_name && touched?.nok_last_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.nok_last_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      MIDDLE NAME
                    </label>
                    {!editing ? (
                      <p>{data?.nok_middle_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='nok_middle_name'
                          value={values.nok_middle_name}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.nok_middle_name &&
                          touched?.nok_middle_name && (
                            <p className='mb-0 text-danger'>
                              {errors?.nok_middle_name + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1 '>
                      GENDER
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{data?.nok_gender}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "nok_gender" } });
                          }}
                          name='nok_gender'
                          data={genderData}
                          value={values.nok_gender}
                          onChange={(selectedOption) =>
                            setFieldValue("nok_gender", selectedOption?.value)
                          }
                        />
                        {errors?.nok_gender && touched?.nok_gender && (
                          <p className='mb-0 text-danger'>
                            {errors?.nok_gender + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      PHONE NUMBER
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{data?.nok_phone}</p>
                    ) : (
                      <div>
                        <PhoneInput
                          placeholder='Enter phone number'
                          value={values.nok_phone}
                          // onChange={handleChange}
                          onChange={(selectedOption) =>
                            setFieldValue("nok_phone", selectedOption)
                          }
                          defaultCountry='NG'
                          name='nok_phone'
                          className='form-control custom-phone-input'
                          onBlur={() => {
                            handleBlur({ target: { name: "nok_phone" } });
                          }}
                        />
                        {errors?.nok_phone && touched?.nok_phone && (
                          <p className='mb-0 text-danger'>
                            {errors?.nok_phone + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      EMAIL
                    </label>
                    {!editing ? (
                      <p>{data?.nok_email}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='nok_email'
                          value={values.nok_email}
                          type='email'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.nok_email && touched?.nok_email && (
                          <p className='mb-0 text-danger'>
                            {errors?.nok_email + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      TYPE OF RELATIONSHIP
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>
                        {data?.nok_type_of_relationship}
                      </p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='nok_type_of_relationship'
                          value={values.nok_type_of_relationship}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.nok_type_of_relationship &&
                          touched?.nok_type_of_relationship && (
                            <p className='mb-0 text-danger'>
                              {errors?.nok_type_of_relationship + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <label htmlFor='middlename' className='fw-bold pb-1'>
                  RESIDENTIAL ADDRESS
                </label>
                {!editing ? (
                  <p>{data?.nok_address}</p>
                ) : (
                  <div>
                    <textarea
                      className='form-control form-control-sm'
                      id='nok_address'
                      value={values.nok_address}
                      type='text'
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {errors?.nok_address && touched?.nok_address && (
                      <p className='mb-0 text-danger'>
                        {errors?.nok_address + "*"}
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div className='col-md-6'></div>
            </div>
          </div>
        </div>
        {editCustomer && data1?.status !== "3" && (
          <div className='row'>
            <div className='d-flex justify-content-end'>
              <div>
                <button
                  type='button'
                  className={`btn btn-${
                    editing ? "warning" : "info"
                  } btn-sm mt-3 px-4 text-white`}
                  onClick={() => {
                    setEditing(editing ? false : true);
                    handleClose();
                  }}
                >
                  {editing ? "Close" : "Edit"}
                </button>
                {editing && (
                  <button
                    className='btn btn-success ms-2 btn-sm mt-3 px-4'
                    type='submit'
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default NextOfKin;
